import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-lg-12" }
const _hoisted_6 = { class: "text-lg-right" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-8" }
const _hoisted_11 = {
  key: 0,
  class: "badge badge-dim badge-success ml-1"
}
const _hoisted_12 = {
  key: 1,
  class: "badge badge-dim badge-success ml-1"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "green-text"
}
const _hoisted_15 = {
  key: 1,
  class: "yellow-text"
}
const _hoisted_16 = {
  key: 2,
  class: "yellow-text"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "mb-2" }
const _hoisted_19 = { class: "mb-0" }
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar-alt mr-2" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_22 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-lg-4" }
const _hoisted_25 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_26 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = { class: "col-lg-8" }
const _hoisted_30 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_31 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { key: 3 }
const _hoisted_34 = {
  key: 0,
  class: "col-lg-8"
}
const _hoisted_35 = { class: "list-accordion mt-2" }
const _hoisted_36 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_37 = { class: "mb-0" }
const _hoisted_38 = { class: "card-body p-2" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "col-md-4 text-md-right" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  key: 2,
  class: "alert alert-success d-inline-block my-4"
}
const _hoisted_45 = {
  key: 0,
  class: "inline-items my-3"
}
const _hoisted_46 = {
  key: 1,
  class: "phaseCard",
  id: "todoInvitations"
}
const _hoisted_47 = { class: "card-head pb-3 mb-0" }
const _hoisted_48 = { class: "row align-items-center mx-n2" }
const _hoisted_49 = { class: "col-3 px-2" }
const _hoisted_50 = { class: "member-heading mb-0" }
const _hoisted_51 = { class: "card-title card-title mb-lg-0" }
const _hoisted_52 = { class: "table-wrap row" }
const _hoisted_53 = { class: "table-responsive" }
const _hoisted_54 = { class: "table table-borderless mb-0 font-12" }
const _hoisted_55 = { class: "table-light" }
const _hoisted_56 = { key: 2 }
const _hoisted_57 = {
  key: 5,
  class: "table-responsive"
}
const _hoisted_58 = { class: "table table-borderless mb-0 font-12" }
const _hoisted_59 = { class: "table-light" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { key: 2 }
const _hoisted_63 = { key: 3 }
const _hoisted_64 = {
  key: 0,
  class: "badge badge-dim badge-success ml-1"
}
const _hoisted_65 = {
  key: 1,
  class: "badge rounded-pill bg-danger text-white ml-1"
}
const _hoisted_66 = { key: 4 }
const _hoisted_67 = { key: 5 }
const _hoisted_68 = { class: "mt-4" }
const _hoisted_69 = /*#__PURE__*/_createVNode("i", { class: "far fa-comment ml-2" }, null, -1)
const _hoisted_70 = /*#__PURE__*/_createVNode("i", { class: "far fa-comment ml-2" }, null, -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("i", { class: "far fa-file-alt" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("i", { class: "far fa-file-alt" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createVNode("i", { class: "far fa-file-alt" }, null, -1)
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = { key: 1 }
const _hoisted_77 = { class: "modal-wrap default-modal" }
const _hoisted_78 = {
  class: "modal fade",
  id: "flagTaskAsCompleted",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_79 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_80 = { class: "modal-content" }
const _hoisted_81 = { class: "modal-header" }
const _hoisted_82 = { class: "d-block" }
const _hoisted_83 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_84 = { class: "text-muted" }
const _hoisted_85 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_86 = { class: "modal-body" }
const _hoisted_87 = { class: "form-wrap pt-0" }
const _hoisted_88 = { class: "form-group" }
const _hoisted_89 = { for: "exampleInputEmail1" }
const _hoisted_90 = { class: "modal-footer" }
const _hoisted_91 = { class: "modal-wrap default-modal" }
const _hoisted_92 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "setInvoiceReceiverModal",
  tabindex: -1,
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_93 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_94 = { class: "modal-content" }
const _hoisted_95 = { class: "modal-header" }
const _hoisted_96 = { class: "d-block" }
const _hoisted_97 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_98 = { class: "text-muted" }
const _hoisted_99 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_100 = { class: "modal-body" }
const _hoisted_101 = { class: "form-wrap pt-0" }
const _hoisted_102 = { class: "form-group" }
const _hoisted_103 = { for: "exampleInputEmail1" }
const _hoisted_104 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_105 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_ToDoMembersList = _resolveComponent("ToDoMembersList")
  const _component_ToDoDetailsAttachment = _resolveComponent("ToDoDetailsAttachment")
  const _component_router_link = _resolveComponent("router-link")
  const _component_ProjectWorkflowToDoPhaseDetailTasks = _resolveComponent("ProjectWorkflowToDoPhaseDetailTasks")
  const _component_ToDoPhaseTaskListUpdateModal = _resolveComponent("ToDoPhaseTaskListUpdateModal")
  const _component_ToDoPhasePaymentRequest = _resolveComponent("ToDoPhasePaymentRequest")
  const _component_ToDoPhasePaymentApproval = _resolveComponent("ToDoPhasePaymentApproval")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_ToDoPhaseChatChannelModel = _resolveComponent("ToDoPhaseChatChannelModel")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.state.ui.isLoading.getPhaseDetails && _ctx.selectedPhase.phase)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("a", {
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToToDoList && _ctx.redirectToToDoList(...args)))
            }, [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_ErrorList, {
        errors: _ctx.state.ui.error.errorList.getPhaseDetails,
        hasError: _ctx.state.ui.error.hasError
      }, null, 8, ["errors", "hasError"]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("p", null, [
            _createVNode("strong", null, _toDisplayString(_ctx.$t('status')) + " : ", 1),
            (_ctx.selectedPhase.phase.status_detail)
              ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.selectedPhase.phase.status_detail.detail), 1))
              : (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.selectedPhase.phase.status), 1))
          ]),
          (_ctx.selectedPhase.phase.priority_id)
            ? (_openBlock(), _createBlock("p", _hoisted_13, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('priority')) + " : ", 1),
                (_ctx.selectedPhase.phase.priority_id === 3)
                  ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('high')), 1))
                  : (_ctx.selectedPhase.phase.priority_id === 2)
                    ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('medium')), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_16, "Low"))
              ]))
            : (_openBlock(), _createBlock("p", _hoisted_17, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('priority')) + " : ", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('n_a')), 1)
              ])),
          _createVNode("div", _hoisted_18, [
            _createVNode("p", _hoisted_19, [
              _hoisted_20,
              _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + " : ", 1),
              _createVNode("span", null, _toDisplayString(_ctx.selectedPhase.phase.localStartedDate
                ? _ctx.selectedPhase.phase.localStartedDate
                : _ctx.$t('n_a')), 1),
              _hoisted_21,
              (_ctx.selectedPhase.phase.localEndDate)
                ? (_openBlock(), _createBlock("span", _hoisted_22, _toDisplayString(_ctx.selectedPhase.phase.localEndDate), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              (
              _ctx.selectedPhase.phase.child_phases &&
              _ctx.selectedPhase.phase.child_phases.length === 0
            )
                ? (_openBlock(), _createBlock("p", _hoisted_25, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('task_name')) + " :", 1)
                  ]))
                : (_openBlock(), _createBlock("p", _hoisted_26, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_name')) + " :", 1)
                  ])),
              (_ctx.selectedPhase.phase && _ctx.selectedPhase.phase.name)
                ? (_openBlock(), _createBlock("p", _hoisted_27, [
                    _createVNode("small", null, _toDisplayString(_ctx.selectedPhase.phase.name), 1)
                  ]))
                : (_openBlock(), _createBlock("p", _hoisted_28, _toDisplayString(_ctx.$t('n_a')), 1))
            ]),
            _createVNode("div", _hoisted_29, [
              (
              _ctx.selectedPhase.phase.child_phases &&
              _ctx.selectedPhase.phase.child_phases.length === 0
            )
                ? (_openBlock(), _createBlock("p", _hoisted_30, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('task_description')) + " :", 1)
                  ]))
                : (_openBlock(), _createBlock("p", _hoisted_31, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_description')) + " :", 1)
                  ])),
              (_ctx.selectedPhase.phase && _ctx.selectedPhase.phase.description)
                ? (_openBlock(), _createBlock("p", _hoisted_32, [
                    _createVNode("small", null, _toDisplayString(_ctx.selectedPhase.phase.description), 1)
                  ]))
                : (_openBlock(), _createBlock("p", _hoisted_33, _toDisplayString(_ctx.$t('n_a')), 1))
            ]),
            (_ctx.selectedPhase.phase.estimation_items)
              ? (_openBlock(), _createBlock("div", _hoisted_34, [
                  _createVNode("div", _hoisted_35, [
                    _createVNode("div", _hoisted_36, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedPhase.phase
                  .estimation_items, (item, itemIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "card p-1",
                          key: itemIndex
                        }, [
                          _createVNode("div", {
                            class: "card-header p-0",
                            id: `heading${itemIndex}`
                          }, [
                            _createVNode("h2", _hoisted_37, [
                              _createVNode("button", {
                                class: "btn btn-link text-left shadow-none collapsed",
                                type: "button",
                                "data-toggle": "collapse",
                                "data-target": `#collapse${itemIndex}`,
                                "aria-expanded": "true",
                                "aria-controls": "collapseOne"
                              }, _toDisplayString(item.name), 9, ["data-target"])
                            ])
                          ], 8, ["id"]),
                          _createVNode("div", {
                            id: `collapse${itemIndex}`,
                            class: "collapse",
                            "aria-labelledby": "headingOne",
                            "data-parent": "#accordionExample"
                          }, [
                            _createVNode("div", _hoisted_38, [
                              _createVNode("div", _hoisted_39, [
                                _createVNode("div", _hoisted_40, [
                                  _createVNode("p", null, [
                                    _createVNode("strong", null, _toDisplayString(_ctx.$t('item_name')), 1)
                                  ]),
                                  _createVNode("p", null, _toDisplayString(item.name), 1),
                                  _createVNode("p", null, [
                                    _createVNode("strong", null, _toDisplayString(_ctx.$t('item_cost')), 1)
                                  ]),
                                  _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(item.cost)), 1)
                                ]),
                                _createVNode("div", _hoisted_41, [
                                  _createVNode("p", null, [
                                    _createVNode("strong", null, _toDisplayString(_ctx.$t('item_description')), 1)
                                  ]),
                                  _createVNode("p", null, _toDisplayString(item.description), 1)
                                ])
                              ])
                            ])
                          ], 8, ["id"])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_42, [
          _createVNode("p", null, [
            _createVNode("strong", null, _toDisplayString(_ctx.$t('members')) + " :", 1)
          ]),
          (_ctx.selectedPhase.phase.allMembers)
            ? (_openBlock(), _createBlock(_component_ToDoMembersList, {
                key: 0,
                projectMembers: _ctx.selectedPhase.phase.allMembers
              }, null, 8, ["projectMembers"]))
            : (_openBlock(), _createBlock("p", _hoisted_43, _toDisplayString(_ctx.$t('n_a')), 1)),
          (_ctx.selectedPhase.role != 2 && _ctx.selectedPhase.phase.estimation &&
          _ctx.selectedPhase.phase.estimation.amount
        )
            ? (_openBlock(), _createBlock("div", _hoisted_44, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('estimation')) + " :", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedPhase.phase.estimation.amount) + " (" + _toDisplayString(_ctx.selectedPhase.phase.estimation.type) + ") ", 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.selectedPhase.attachments && _ctx.selectedPhase.attachments.length)
        ? (_openBlock(), _createBlock("div", _hoisted_45, [
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('attachments')) + " :", 1)
            ]),
            _createVNode("ul", null, [
              _createVNode(_component_ToDoDetailsAttachment, {
                todoAttachments: _ctx.selectedPhase.attachments
              }, null, 8, ["todoAttachments"])
            ])
          ]))
        : _createCommentVNode("", true),
      (
      _ctx.selectedPhase.phase_invitations &&
      _ctx.selectedPhase.phase_invitations.length
    )
        ? (_openBlock(), _createBlock("div", _hoisted_46, [
            _createVNode("div", _hoisted_47, [
              _createVNode("div", _hoisted_48, [
                _createVNode("div", _hoisted_49, [
                  _createVNode("div", _hoisted_50, [
                    _createVNode("h3", _hoisted_51, _toDisplayString(_ctx.$t('phase_invitations')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_52, [
              _createVNode("div", _hoisted_53, [
                _createVNode("table", _hoisted_54, [
                  _createVNode("thead", _hoisted_55, [
                    _createVNode("tr", null, [
                      _createVNode("td", null, _toDisplayString(_ctx.$t('invitations')), 1),
                      _createVNode("td", null, _toDisplayString(_ctx.$t('action')), 1)
                    ])
                  ]),
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedPhase.phase_invitations, (phase, phaseIndex) => {
                      return (_openBlock(), _createBlock("tr", { key: phaseIndex }, [
                        _createVNode("td", null, [
                          _createVNode(_component_router_link, {
                            to: {
                    name: 'user-phase-task-invitation-acknowledgement',
                    params: { invitationId: phase.uuid },
                  }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(phase.description), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createVNode("td", null, [
                          _createVNode(_component_router_link, {
                            class: "default-btn d-block",
                            to: {
                    name: 'user-phase-task-invitation-acknowledgement',
                    params: { invitationId: phase.uuid },
                  }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('view_details')), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (
      _ctx.selectedPhase.phase.child_phases &&
      _ctx.selectedPhase.phase.child_phases.length
    )
        ? (_openBlock(), _createBlock("p", _hoisted_56, [
            _createVNode("strong", null, _toDisplayString(_ctx.$t('no_of_tasks')) + " :", 1)
          ]))
        : _createCommentVNode("", true),
      (
      _ctx.selectedPhase.phase.child_phases &&
      _ctx.selectedPhase.phase.child_phases.length
    )
        ? (_openBlock(), _createBlock(_component_ProjectWorkflowToDoPhaseDetailTasks, {
            key: 3,
            subPhases: _ctx.selectedPhase.phase.child_phases,
            project: _ctx.selectedPhase.project,
            role: _ctx.selectedPhase.role,
            phaseId: _ctx.state.data.phaseId,
            showAction: true,
            phase: _ctx.selectedPhase.phase,
            onSelectedTasks: _ctx.selectedTasks,
            onCheckedTask: _ctx.checkedTask,
            onUpdatePhase: _ctx.addNewPhase,
            onUpdateLog: _ctx.updateLog,
            onUpdatePhaseList: _ctx.updatePhaseList
          }, null, 8, ["subPhases", "project", "role", "phaseId", "phase", "onSelectedTasks", "onCheckedTask", "onUpdatePhase", "onUpdateLog", "onUpdatePhaseList"]))
        : _createCommentVNode("", true),
      (
      (_ctx.selectedPhase.phase.child_phases &&
        _ctx.selectedPhase.phase.child_phases.length &&
        _ctx.phaseStatus &&
        _ctx.selectedPhase.role === 1) ||
      (_ctx.selectedPhase.phase.child_phases &&
        _ctx.selectedPhase.phase.child_phases.length &&
        _ctx.phaseStatus &&
        _ctx.selectedPhase.role === 4) ||
      (_ctx.selectedPhase.phase.child_phases &&
        _ctx.selectedPhase.phase.child_phases.length &&
        _ctx.selectedPhase.phase.todayLog &&
        _ctx.selectedPhase.role === 5)
    )
        ? (_openBlock(), _createBlock("a", {
            key: 4,
            class: "btn default-btn mr-2",
            href: "javascript:void(0)",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToPhaseLogs && _ctx.redirectToPhaseLogs(...args)))
          }, _toDisplayString(_ctx.$t('see_logs')), 1))
        : _createCommentVNode("", true),
      (
      _ctx.selectedPhase.completionStatus &&
      _ctx.selectedPhase.completionStatus.detail &&
      _ctx.selectedPhase.completionStatus.detail.length
    )
        ? (_openBlock(), _createBlock("div", _hoisted_57, [
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('task_completion_status')) + " : ", 1)
            ]),
            _createVNode("table", _hoisted_58, [
              _createVNode("thead", _hoisted_59, [
                _createVNode("tr", null, [
                  _createVNode("td", null, _toDisplayString(_ctx.$t('date')), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.$t('name')), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.$t('email')), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.$t('details')), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.$t('total_wages')), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.$t('status')), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.$t('invoice')), 1)
                ])
              ]),
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedPhase.completionStatus.detail, (task, taskIndex) => {
                  return (_openBlock(), _createBlock("tr", { key: taskIndex }, [
                    _createVNode("td", null, _toDisplayString(task.created_at), 1),
                    _createVNode("td", null, _toDisplayString(task.user.full_name), 1),
                    _createVNode("td", null, _toDisplayString(task.user.email), 1),
                    (task.detail)
                      ? (_openBlock(), _createBlock("td", _hoisted_60, _toDisplayString(task.detail), 1))
                      : (_openBlock(), _createBlock("td", _hoisted_61, "-")),
                    (task.wage)
                      ? (_openBlock(), _createBlock("td", _hoisted_62, [
                          _createVNode("strong", null, " $ " + _toDisplayString(task.wage), 1)
                        ]))
                      : (_openBlock(), _createBlock("td", _hoisted_63, "-")),
                    _createVNode("td", null, [
                      (task.completed === 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_64, _toDisplayString(_ctx.$t('in_progress1')), 1))
                        : (_openBlock(), _createBlock("span", _hoisted_65, _toDisplayString(_ctx.$t('close')), 1))
                    ]),
                    (task.invoice_id)
                      ? (_openBlock(), _createBlock("td", _hoisted_66, [
                          _createVNode("button", {
                            onClick: ($event: any) => (_ctx.redirectToSelectedInvoice(task.invoice_id, '2')),
                            class: "invoice-btn"
                          }, _toDisplayString(_ctx.$t('invoice')), 9, ["onClick"])
                        ]))
                      : (_openBlock(), _createBlock("td", _hoisted_67, "-"))
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_68, [
        (
        (_ctx.phaseStatus &&
          _ctx.selectedPhase.role === 4 &&
          _ctx.selectedPhase.completionStatus &&
          _ctx.selectedPhase.completionStatus.status === 1) ||
        (_ctx.phaseStatus &&
          _ctx.selectedPhase.role === 1 &&
          _ctx.selectedPhase.completionStatus &&
          _ctx.selectedPhase.completionStatus.status === 1) && !(_ctx.projectStatus ==2)
      )
          ? (_openBlock(), _createBlock("a", {
              key: 0,
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showFlagCompleteTask && _ctx.showFlagCompleteTask(...args)))
            }, _toDisplayString(_ctx.state.ui.isPostLoading.phaseCompleted
            ? _ctx.$t('loading1')
            : _ctx.$t('flag_as_completed')), 1))
          : _createCommentVNode("", true),
        (_ctx.phaseStatus && _ctx.selectedPhase.role != 5 && !(_ctx.projectStatus ==2))
          ? (_openBlock(), _createBlock("a", {
              key: 1,
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block mr-3",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.redirectToChat && _ctx.redirectToChat(...args)))
            }, [
              _hoisted_69,
              _createTextVNode(" " + _toDisplayString(_ctx.state.ui.isPostLoading.redirectToChat
            ? _ctx.$t('loading1')
            : _ctx.$t('give_feedback')), 1)
            ]))
          : _createCommentVNode("", true),
        (!(_ctx.projectStatus ==2))
          ? (_openBlock(), _createBlock("a", {
              key: 2,
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block mr-3",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.redirectToChat && _ctx.redirectToChat(...args)))
            }, [
              _hoisted_70,
              _createTextVNode(" " + _toDisplayString(_ctx.state.ui.isPostLoading.redirectToChat
            ? _ctx.$t('loading1')
            : _ctx.$t('give_feedback')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.invoiceGeneratePermissionByRole && !(_ctx.projectStatus ==2))
          ? (_openBlock(), _createBlock("a", {
              key: 3,
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block mr-3",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.redirectToInvoice && _ctx.redirectToInvoice(...args)))
            }, [
              _hoisted_71,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('invoice')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isActiveGenerateInvoice)
          ? (_openBlock(), _createBlock("a", {
              key: 4,
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block invoice-request-send mr-3",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.checkGenerateInvoice && _ctx.checkGenerateInvoice(...args)))
            }, [
              _hoisted_72,
              _createTextVNode(" " + _toDisplayString(_ctx.state.ui.isPostLoading.showInvoiceReceiverModal
            ? _ctx.$t('loading1')
            : _ctx.$t('generate_invoice')), 1)
            ]))
          : _createCommentVNode("", true),
        (
        _ctx.selectedPhase.role === 3 &&
        _ctx.selectedPhase.phase.parent_phase === null &&
        _ctx.selectedPhase.invoices &&
        _ctx.selectedPhase.invoices.sent_invoice != null &&
        _ctx.selectedPhase.invoices.sent_invoice.uuid
      )
          ? (_openBlock(), _createBlock("a", {
              key: 5,
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block invoice-request-send mr-3",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (
          _ctx.redirectToAllInvoice(_ctx.selectedPhase.invoices.sent_invoice.uuid, '2')
          ))
            }, [
              _hoisted_73,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('view_requested_invoices')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.state.data.showAddPhaseModal)
      ? (_openBlock(), _createBlock(_component_ToDoPhaseTaskListUpdateModal, {
          key: 1,
          editMode: _ctx.state.data.editMode,
          projectDetail: _ctx.selectedPhase.project,
          projectAcknowledgementDetail: _ctx.selectedPhase.phase,
          phase: _ctx.selectedPhase.phase,
          todoDetail: _ctx.selectedPhase.phase.todo,
          showAddPhase: _ctx.state.data.showAddPhaseModal,
          onClose: _ctx.showAddPhaseModal,
          onAddPhase: _ctx.addNewPhase,
          onUpdatePhaseList: _ctx.updatePhaseList
        }, null, 8, ["editMode", "projectDetail", "projectAcknowledgementDetail", "phase", "todoDetail", "showAddPhase", "onClose", "onAddPhase", "onUpdatePhaseList"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showPhasePaymentRequestModal)
      ? (_openBlock(), _createBlock(_component_ToDoPhasePaymentRequest, {
          key: 2,
          showAddPhase: _ctx.state.data.showPhasePaymentRequestModal,
          role: _ctx.selectedPhase.role,
          phase: _ctx.selectedPhase.phase,
          onClose: _ctx.hideToDoPhasePaymentRequest
        }, null, 8, ["showAddPhase", "role", "phase", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showPaymentRequestApprovalModal)
      ? (_openBlock(), _createBlock(_component_ToDoPhasePaymentApproval, {
          key: 3,
          showAddPhase: _ctx.state.data.showPaymentRequestApprovalModal,
          phase: _ctx.selectedPhase.phase,
          role: _ctx.selectedPhase.role,
          onClose: _ctx.closePaymentApproval
        }, null, 8, ["showAddPhase", "phase", "role", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 4,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFullMessage,
          isButton: "true"
        }, {
          default: _withCtx(() => [
            (
      _ctx.state.data.generatedInvoiceDetails &&
      _ctx.state.data.generatedInvoiceDetails.invoice &&
      _ctx.state.data.generatedInvoiceDetails.invoice.uuid
    )
              ? (_openBlock(), _createBlock("div", _hoisted_74, [
                  _createVNode("p", null, _toDisplayString(_ctx.$t('see_invoice_generated')), 1),
                  _createVNode("button", {
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.seeInvoiceGenerated && _ctx.seeInvoiceGenerated(...args)))
                  }, _toDisplayString(_ctx.$t('click_to_see')) + ".", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.stripeUrl)
              ? (_openBlock(), _createBlock("div", _hoisted_75, [
                  _createVNode("p", null, _toDisplayString(_ctx.$t('you_dont_have_stripe_account')), 1),
                  (!_ctx.state.ui.isPostLoading.stripeAccount)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        class: "btn-link mt-2",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.redirectToStripeAccount && _ctx.redirectToStripeAccount(...args)))
                      }, _toDisplayString(_ctx.$t('click_to_setup_account')), 1))
                    : (_openBlock(), _createBlock("p", _hoisted_76, _toDisplayString(_ctx.$t('loading1')), 1))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showPhaseChannelModal)
      ? (_openBlock(), _createBlock(_component_ToDoPhaseChatChannelModel, {
          key: 5,
          phase: _ctx.selectedPhase.phase,
          showPhaseChannel: _ctx.state.data.showPhaseChannelModal,
          onClose: _ctx.hidePhaseChannel
        }, null, 8, ["phase", "showPhaseChannel", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_77, [
      _createVNode("div", _hoisted_78, [
        _createVNode("div", _hoisted_79, [
          _createVNode("div", _hoisted_80, [
            _createVNode("div", _hoisted_81, [
              _createVNode("div", _hoisted_82, [
                _createVNode("h5", _hoisted_83, _toDisplayString(_ctx.$t('task_completed')), 1),
                _createVNode("p", _hoisted_84, _toDisplayString(_ctx.$t('flag_this_project_as_task_completed')) + ".", 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.hideFlagCompleteTask && _ctx.hideFlagCompleteTask(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_85
              ])
            ]),
            _createVNode("div", _hoisted_86, [
              _createVNode("div", _hoisted_87, [
                _createVNode("div", _hoisted_88, [
                  _createVNode("label", _hoisted_89, _toDisplayString(_ctx.$t('details')), 1),
                  _withDirectives(_createVNode("input", {
                    type: "email",
                    class: "form-control",
                    id: "taskcompletionDetail",
                    "aria-describedby": "emailHelp",
                    placeholder: _ctx.$t('task_completion_details'),
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.data.taskCompletionDetails = $event))
                  }, null, 8, ["placeholder"]), [
                    [_vModelText, _ctx.state.data.taskCompletionDetails]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_90, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.phaseCompleted && _ctx.phaseCompleted(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.phaseCompleted
                ? _ctx.$t('loading1')
                : _ctx.$t('flag_as_completed')), 1),
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn secondary-btn",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.hideFlagCompleteTask && _ctx.hideFlagCompleteTask(...args)))
              }, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_91, [
      _createVNode("div", _hoisted_92, [
        _createVNode("div", _hoisted_93, [
          _createVNode("div", _hoisted_94, [
            _createVNode("div", _hoisted_95, [
              _createVNode("div", _hoisted_96, [
                _createVNode("h5", _hoisted_97, _toDisplayString(_ctx.$t('send_invoice')), 1),
                _createVNode("p", _hoisted_98, _toDisplayString(_ctx.$t('please_select_person_to_send_invoice')) + ". ", 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.hideInvoiceReceiverModal && _ctx.hideInvoiceReceiverModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_99
              ])
            ]),
            _createVNode("div", _hoisted_100, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.error.errorList.generateInvoice,
                hasError: _ctx.state.ui.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_101, [
                _createVNode("div", _hoisted_102, [
                  _createVNode("label", _hoisted_103, _toDisplayString(_ctx.$t('invoice_receiver')), 1),
                  _withDirectives(_createVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.state.data.selectedInvoiceReceiverId = $event))
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                    .invoiceReceiverList, (receiver, receiverIndex) => {
                      return (_openBlock(), _createBlock("option", {
                        value: receiver.id,
                        key: receiverIndex,
                        selected: receiver.permission === null
                      }, _toDisplayString(receiver.full_name) + " - " + _toDisplayString(receiver.email), 9, ["value", "selected"]))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.state.data.selectedInvoiceReceiverId]
                  ])
                ]),
                _hoisted_104
              ])
            ]),
            _createVNode("div", _hoisted_105, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.generateInvoice && _ctx.generateInvoice(...args))),
                disabled: _ctx.state.ui.isPostLoading.generateInvoice
              }, _toDisplayString(_ctx.state.ui.isPostLoading.generateInvoice ? _ctx.$t('loading1') : _ctx.$t('send')), 9, ["disabled"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}